import { apiGet, apiPatch } from './client';
import type { Trustee, TrusteeBatchRequest } from '../types/Trustee';

export function getTrustees(): Promise<Trustee[]> { return apiGet<Trustee[]>('/api/trustees'); }

export function saveBatchTrustees(added: Trustee[], modified: Trustee[], deletedIds: number[]): Promise<Trustee[]> {
  return apiPatch<TrusteeBatchRequest, Trustee[]>('/api/trustees/batch', { added, modified, deleted: deletedIds });
}
